export enum NotificationType {
  Snackbar = 'Snackbar',
}
